export const maskValue = (inputString: string) => {
  if (inputString && inputString.length >= 4) {
    return inputString.substring(inputString.length - 4);
  } else {
    return '';
  }
};
